import { render, staticRenderFns } from "./PrincipalView.vue?vue&type=template&id=1bcc118e&"
import script from "./principal.js?vue&type=script&lang=js&"
export * from "./principal.js?vue&type=script&lang=js&"
import style0 from "./PrincipalView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports